
































import { Component, Vue, Provide, Prop } from "vue-property-decorator";
import { GetOverdueCaseReq } from "@/pbjs/xcommon/collection_pb.js";
import { collectionServiceClient } from "@/api";
import { localGet, timeFormat } from "@/utils";
import { pagnition } from "@/utils/commonConfig";

@Component({
  name: "newOrder",
})
export default class CombinationProperty extends Vue {
  @Prop() private tableData: any;
  @Prop() private labelData: any;
  // @Prop() pageSize: any;  //分页页数
  @Prop() pagerCount: any; //总条数
  @Provide() private token: any = ""; // token
  @Provide() private pageSize: any = 20;
  @Provide() private pageIndex: any = 1; //当前页
  @Provide() private pagnition: any = pagnition;
  get tabledData() {
    return this.tableData;
  }

  private handleCurrentChange(val: any) {
    this.pageIndex = Number(val);
    //展示表格数据
    this.$emit("refreshTable", this.pageIndex, this.pageSize);
  }

  //点击上一页
  private handlePrevChange(val: any) {
    if (this.pageIndex > 0) {
      //展示表格数据
      this.$emit("refreshTable", this.pageIndex, this.pageSize);
    }
  }

  //点击下一页
  private handleNextChange(val: any) {
    //展示表格数据
    this.$emit("refreshTable", this.pageIndex, this.pageSize);
  }

  private handleSizeChange(val: any) {
    this.pageSize = Number(val);
    //展示表格数据
    this.$emit("refreshTable", this.pageIndex, this.pageSize);
  }
}
